// Spec: specs/payments/prepay/functional_requirements.md §3.4.1, §6.5
//       specs/account/billing-info/functional_requirements.md §5
//
// The provider's browser client. One instance per publishable key for the life of the
// document: the client owns iframes and a message channel, so a second instance for the
// same key doubles both and leaves the first one listening.

import { loadStripe, Stripe } from '@stripe/stripe-js'

const clients = new Map<string, Promise<Stripe | null>>()

export const loadStripeClient = (publishableKey: string): Promise<Stripe | null> => {
  if (!publishableKey) return Promise.resolve(null)

  const cached = clients.get(publishableKey)
  if (cached) return cached

  // The assistant is the provider's own floating launcher, pinned to the corner of the window
  // above our page whenever the key is a test one. It is built for whoever is integrating, not for
  // the people using this product, and neither environment we ship to wants it on screen.
  const client = loadStripe(publishableKey, { developerTools: { assistant: { enabled: false } } })
  clients.set(publishableKey, client)
  return client
}
